import { getUrl, getSSIUrl } from "@xo-union/dist-url";
const DIST_NAME = 'tk-pagelet-header-nav';
export const getHeaderAssetUrl = (tag, path) => getUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});
export const getHeaderSSIUrl = (tag, path) => getSSIUrl({
  params: {
    name: DIST_NAME,
    tag,
    path
  }
});